// extracted by css-extract-rspack-plugin
export default {"root":"root-sYzWom","bold":"bold-wPNKh1"};